import * as React from "react"

const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1880_9116)">
    <path d="M4 6H20" stroke="#433F4E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 12H20" stroke="#433F4E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 18H20" stroke="#433F4E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_1880_9116">
    <rect width="24" height="24" fill="white"/>
    </clipPath>
    </defs>
  </svg>
)
export default MenuIcon
